module.exports = __webpack_public_path__ + "img/ho-facil-blue.192673f1.png";